export default __webpack_public_path__ + "static/media/Group2602.23c5723e.png";